import leftPad from 'left-pad';
export default function (value, length) {
	if (value) {
		return leftPad(value, length, '0');
	} else {
		return '';
	}
}
